import React, { useEffect, useState } from "react";
import { Box, Typography, Avatar, Rating } from "@mui/material";
import { Link } from "react-router-dom";
import DisplayReview from "../reviews/DisplayReview";
import axios from "axios";
import config from "../../../config";
import { connect } from "react-redux";

const ReviewRow = ({ review }) => {
  const [showReview, setShowReview] = useState(false);
  return (
    <>
      <DisplayReview openModal={showReview} closeModal={() => setShowReview(false)} data={review} />
      <Box
        onClick={() => setShowReview(true)}
        sx={{
          display: "flex", alignItems: "center", gap: 1.5, px: 1.5, py: 1.2,
          cursor: "pointer", borderRadius: "10px", transition: "0.2s",
          "&:hover": { backgroundColor: "rgba(255,192,1,0.04)" },
        }}
      >
        <Avatar
          src={review.user?.avatar_url}
          alt={review.user?.full_name}
          sx={{ width: 34, height: 34, flexShrink: 0 }}
        />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontWeight: 700, fontSize: "13px", color: "#ddd" }}>
            {review.user?.full_name}
          </Typography>
          <Typography noWrap sx={{ fontSize: "12px", color: "#555" }}>
            {review.content}
          </Typography>
        </Box>
        <Rating
          value={review.rating}
          readOnly
          size="small"
          sx={{ flexShrink: 0, "& .MuiRating-iconFilled": { color: "#FFC001" }, "& .MuiRating-iconEmpty": { color: "#333" } }}
        />
      </Box>
    </>
  );
};

const SellerDashboardMessegeList = ({ seller, jwtToken }) => {
  const [reviewData, setReviewData] = useState([]);

  useEffect(() => {
    if (!seller?.id) return;
    const fetchReviews = async () => {
      try {
        const res = await axios.get(`${config.SERVER_URL}/api/v1/reviews?seller_id=${seller.id}`, {
          headers: { Authorization: `Bearer ${jwtToken}` },
        });
        if (res.status === 200) {
          const reviews = res.data.reviews || [];
          const planName = seller?.user?.subscriptions?.[0]?.plan?.name;
          const limitedPlans = ["Silver", "Free"];
          const filtered = planName && limitedPlans.includes(planName)
            ? reviews.filter(r => r.reviewable_type === "ListingAnimal")
            : reviews;
          setReviewData(filtered);
        }
      } catch {}
    };
    fetchReviews();
  }, [seller]);

  return (
    <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", overflow: "hidden" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2.5, py: 1.5, borderBottom: "1px solid #222" }}>
        <Typography sx={{ fontWeight: 700, fontSize: "14px", color: "#fff" }}>Recent Reviews</Typography>
        <Typography
          component={Link}
          to="/seller/reviews"
          sx={{ color: "#FFC001", fontSize: "12px", fontWeight: 600, textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
        >
          View All
        </Typography>
      </Box>
      <Box sx={{ py: 0.5, maxHeight: 280, overflowY: "auto" }}>
        {reviewData.length > 0 ? (
          reviewData.slice(0, 6).map((r, i) => <ReviewRow key={i} review={r} />)
        ) : (
          <Typography sx={{ color: "#555", fontSize: "13px", textAlign: "center", py: 3 }}>
            No reviews yet
          </Typography>
        )}
      </Box>
    </Box>
  );
};

const mapStateToProps = ({ Auth, Seller }) => ({
  seller: Seller.seller,
  jwtToken: Auth.jwtToken,
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SellerDashboardMessegeList);
